import {
    ActionStatus,
    createFailure,
    createListTableColumns,
    FailureSeverity,
    ListTableColumn,
    renderDate,
    renderTextWithTooltip,
    ValidationFailure
} from "sprint-common-web";

import { renderActionStatus } from "../../../../../../common/utils/renderActionStatus";
import { CloudFileListingItem } from "../../../types/CloudFileListingItem";

type ProcessCloudFileWaitingForClientResponseItem = CloudFileListingItem & {
    processStatus: ActionStatus;
};

export const createCloudFileWaitingForClientResponseColumns = (): ListTableColumn<
    ProcessCloudFileWaitingForClientResponseItem
>[] => {
    return createListTableColumns<ProcessCloudFileWaitingForClientResponseItem>([
        {
            type: "basic",
            key: "deliveryFileName",
            name: "File name",
            minWidth: 150,
            maxWidth: 200,
            onRender: renderTextWithTooltip
        },
        {
            type: "basic",
            key: "filePath",
            name: "File path",
            minWidth: 150,
            maxWidth: 300,
            onRender: renderTextWithTooltip
        },
        {
            type: "basic",
            key: "deliveryRef",
            name: "Reference",
            minWidth: 100,
            maxWidth: 150
        },
        {
            type: "basic",
            key: "originator",
            name: "Originator",
            minWidth: 150,
            maxWidth: 150
        },
        {
            type: "basic",
            key: "arrivalDate",
            name: "Arrival date",
            minWidth: 150,
            maxWidth: 150,
            onRender: renderDate
        },
        {
            type: "basic",
            key: "processStatus",
            name: "Process status",
            minWidth: 100,
            onRender: renderActionStatus
        }
    ]);
};

const discardedCloudFilesInfoMessage = `Cloud files with status other than In Qc have been discarded.`;

export const validateDiscardedCloudFilesOnWaitingForClientResponse = (
    items: CloudFileListingItem[],
    selectedItemsCount: number
): ValidationFailure | void => {
    if (!items.length) {
        return createFailure(
            `${discardedCloudFilesInfoMessage}. Nothing to change to Waiting for client response.`,
            "no-orders-to-deliver",
            FailureSeverity.Error
        );
    } else if (items.length < selectedItemsCount) {
        return createFailure(discardedCloudFilesInfoMessage, "orders-discarded-from-delivery", FailureSeverity.Warning);
    }
};
